// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__XYqYz","info":"PatientInfo_info__29Y6z"};